<article class="tw-ring-1 tw-ring-gray-200 tw-p-4 tw-rounded-[18px] tw-flex tw-flex-col tw-shadow-md tw-bg-white">

    <div class="tw-font-poppins">
        <div class="tw-flex tw-items-center tw-gap-2 tw-justify-between">
            <time class="tw-border-[1px] tw-border-red-600 tw-text-xs tw-text-gray-500" [attr.datetime]="request.createdAt"
            [title]="request.createdAt | date : 'MMM d, YYYY hh:mm a'" itemprop="datePublished">
            <i class="fa-solid fa-badge-check tw-text-rd-500 tw-text-sm"></i> {{ request?.createdAt | chatDate }}
        </time>
        <span class="tw-bg-rd-500 tw-rounded-2xl tw-px-2 tw-py-1 tw-text-xs tw-text-white">
            <i [class]="request?.type === 'Data' ? 'fa-solid fa-database' : 'fa-solid fa-memo'"></i>
            {{request?.type}}
        </span>
        </div>
        <h5 class="tw-text-base tw-text-gray-800">{{request.title}}</h5>
        <p class="tw-text-sm tw-text-gray-500" *ngIf="request?.type == 'Document'"><a [href]="request?.documentDetails?.doi" target="_blank" class="tw-text-rd-500 tw-no-underline hover:tw-underline hover:tw-text-rd-800">{{request?.documentDetails?.doi}}</a></p>
        <!-- <p class="tw-text-sm tw-text-gray-500" *ngIf="request?.type == 'Document'">This document request has been submitted by
            {{request?.requestBy?.firstName + ' ' + request?.requestBy?.lastName}} and is identified under the Digital
            Object Identifier (DOI): {{request?.documentDetails?.doi}}. The request was authored by
            {{request?.documentDetails?.author}} and officially published by {{request?.documentDetails?.publisher}} on
            {{request?.documentDetails?.publishedDate | date : 'MMM d, YYYY'}}.</p> -->
            <p class="tw-text-sm tw-text-gray-500" *ngIf="request?.type == 'Data'">{{request?.dataDetails?.description}}</p>
        <app-divider text="Request Breakdown"></app-divider>

        <!-- When type is Document -->
        <div class="tw-my-2 tw-flex tw-gap-2 tw-justify-evenly tw-items-center lg:tw-flex-row tw-flex-col" *ngIf="request?.type == 'Document'">
            <div class="tw-flex tw-flex-col-reverse tw-items-center lg:tw-flex-col lg:tw-flex-1">
                <p class="tw-m-0 tw-text-gray-800 tw-font-semibold tw-text-sm tw-text-center tw-line-clamp-1" [title]="request?.documentDetails?.author | titlecase">
                    {{request?.documentDetails?.author | titlecase}}
                </p>
                <span class="tw-text-gray-500 tw-text-xs">Author</span>
            </div>
            
            <span class="text-center tw-text-gray-400 tw-hidden lg:tw-inline" aria-hidden="true">|</span>

            <div class="tw-flex tw-flex-col-reverse tw-items-center lg:tw-flex-col lg:tw-flex-1">
                <p class="tw-m-0 tw-text-gray-800 tw-font-semibold tw-text-sm tw-text-center tw-line-clamp-1" [title]="request?.documentDetails?.publisher || 'N/A' | titlecase">
                    {{request?.documentDetails?.publisher || 'N/A' | titlecase}}
                </p>
                <span class="tw-text-gray-500 tw-text-xs">Publisher</span>
            </div>

            <span class="text-center tw-text-gray-400 tw-hidden lg:tw-inline" aria-hidden="true">|</span>

            <div class="tw-flex tw-flex-col-reverse tw-items-center lg:tw-flex-col lg:tw-flex-1">
                <p class="tw-m-0 tw-text-gray-800 tw-font-semibold tw-text-sm tw-text-center tw-line-clamp-1" [title]="request?.documentDetails?.publishedDate || 'N/A' | date : 'MMM d, YYYY'">
                    {{request?.documentDetails?.publishedDate || 'N/A' | date : 'MMM d, YYYY'}}
                </p>
                <span class="tw-text-gray-500 tw-text-xs">Published On</span>
            </div>
        </div>

        <!-- When type is Data -->
        <div class="tw-my-2 tw-flex tw-gap-2 tw-justify-evenly tw-items-center lg:tw-flex-row tw-flex-col" *ngIf="request?.type == 'Data'">
            <div class="tw-flex tw-flex-col tw-items-center lg:tw-flex-1">
                <p class="tw-m-0 tw-text-gray-800 tw-font-semibold tw-text-sm tw-line-clamp-1" [title]="request?.dataDetails?.type">
                    {{request?.dataDetails?.type}}
                </p>
                <span class="tw-text-gray-500 tw-text-xs">Data Type</span>
            </div>

            <span class="text-center tw-text-gray-400  tw-hidden lg:tw-inline" aria-hidden="true">|</span>

            <div class="tw-flex tw-flex-col tw-items-center lg:tw-flex-1">
                <p class="tw-m-0 tw-text-gray-800 tw-font-semibold tw-text-sm tw-line-clamp-1" [title]="request?.dataDetails?.title">
                    {{request?.dataDetails?.title?.length > 30 ? request?.dataDetails?.title?.slice(0,30) + '...' : request?.dataDetails?.title}}
                </p>
                <span class="tw-text-gray-500 tw-text-xs">Data Set</span>
            </div>
        </div>
    </div>
    <div class="tw-flex sm:tw-items-center tw-gap-2 tw-border-b-2 tw-font-inter tw-justify-between tw-flex-col sm:tw-flex-row">
        <div class="tw-flex tw-items-center tw-gap-2">
            <img [src]="request?.requestBy?.profilePicture || defaultAvatar"
            alt="" width="50" height="50" class="tw-object-cover tw-rounded-full" />
        <div class="">
            <h6 class="tw-m-0">{{request?.requestBy?.firstName + ' ' + request?.requestBy?.lastName | titlecase}} </h6>
            <span class="tw-bg-gray-200 tw-rounded-lg tw-px-2 tw-text-xs">
                Researcher
            </span>
        </div>
        </div>
        <app-button label="Help Fulfill" icon="fa-solid fa-hand-holding-heart" size="small" btnClass="!tw-font-poppins !tw-w-full sm:!tw-w-auto" (click)="handleFulfill($event)"></app-button>
    </div>

</article>